module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top-slider"
  }, [_c('div', {
    staticClass: "content-wrapper slider1 hide-me"
  }, [_c('div', {
    staticClass: "animated fadeIn points-hk hide-me"
  }, [_c('div', {
    staticClass: "point point1"
  }), _vm._v(" "), _c('div', {
    staticClass: "point point2"
  })]), _vm._v(" "), _c('h1', {
    staticClass: "title title-hk hide-me"
  }, [_vm._v("始于港澳台")]), _vm._v(" "), _c('div', {
    staticClass: "points-asia hide-me"
  }), _vm._v(" "), _c('h1', {
    staticClass: "title title-asia hide-me"
  }, [_vm._v("精于东南亚")]), _vm._v(" "), _c('div', {
    staticClass: "points-global1 hide-me"
  }), _vm._v(" "), _c('div', {
    staticClass: "points-global2 hide-me"
  }), _vm._v(" "), _c('div', {
    staticClass: "points-global3 hide-me"
  }), _vm._v(" "), _c('h1', {
    staticClass: "title title-global hide-me"
  }, [_vm._v("成于全球")])]), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper slider2 hide-me"
  }, [_c('div', {
    staticClass: "title title-platform hide-me"
  }, [_vm._v("打造全球顶尖游戏发行平台")]), _vm._v(" "), _c('div', {
    staticClass: "dia dia1 faa-pulse animated"
  }, [_vm._v("精品")]), _vm._v(" "), _c('div', {
    staticClass: "dia dia2 faa-pulse animated"
  }, [_vm._v("快速")]), _vm._v(" "), _c('div', {
    staticClass: "dia dia3 faa-pulse animated"
  }, [_vm._v("专业")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d9068c92!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/about/AboutSlider.vue
// module id = 393
// module chunks = 2